// extracted by mini-css-extract-plugin
export default {"container":"QSMJwm","containerTitle":"yCmqHB","clearLink":"yfONoL","pillbox":"C7_QTw","pillbox__text":"oqS4ZI","pillbox__icon":"VqWzsG"};